const fb = require('firebase');
// Required for side-effects
require('firebase/firestore');
require('firebase/analytics');
require('firebase/database');
require('firebase/storage')

// Initialize Cloud Firestore through Firebase
export const firebase = fb.initializeApp({
  apiKey: 'AIzaSyA5olzmHOBsQJqpomUJh5JHTuYZd4cSpxE',
  authDomain: 'order-chat-app.firebaseapp.com',
  databaseURL: 'https://order-chat-app.firebaseio.com',
  projectId: 'order-chat-app',
  storageBucket: 'order-chat-app.appspot.com',
  messagingSenderId: '291230294961',
  appId: '1:291230294961:web:d4f2384bff22e916d81390',
  measurementId: 'G-T0LEYFV1W0'
});

export const db = firebase.firestore();
const realtimeDB = firebase.database();
const auth = firebase.auth();
const storage = firebase.storage();

export const signInDeafaultUser = () => {
  return new Promise((resolve, reject) => {
    auth
      .setPersistence(fb.auth.Auth.Persistence.LOCAL)
      .then(function() {
        auth
          .signInWithEmailAndPassword('brian.smith@manna.aero', 'qwerty12345')
          .then(user => {
            resolve(user);
          });
      })
      .catch(function(error) {
        reject(error);
      });
  });
};

export const getAllNotifications = (success, failure) => {
  db.collection('notifications/list/all').onSnapshot(
    snapshot => {
      const notifs = [];
      snapshot.forEach(doc => {
        const docData = doc.data();
        notifs.push({ id: doc.id, ...docData });
      });
      success(notifs);
    },
    err => {
      failure(err);
    }
  );
};

export const getNotfications = (success, failure) => {
  db.collection('notifications/list/all')
    .where('active', '==', false)
    .onSnapshot(
      snapshot => {
        const notifs = [];
        snapshot.forEach(doc => {
          const docData = doc.data();
          notifs.push({ id: doc.id, ...docData });
        });
        success(notifs);
      },
      err => {
        failure(err);
      }
    );
};

export const getConfig = (success, failure) => {
  db.collection('notifications')
    .doc('config')
    .onSnapshot(
      doc => {
        success(doc.data());
      },
      err => {
        failure(err);
      }
    );
};

export const getPhoneNumbersAmount = (success, failure) => {
  db.collection('phoneNumbers').onSnapshot(
    snap => {
      success(snap.size);
    },
    err => {
      failure(err);
    }
  );
};

export const getActiveNotif = (cellName, success, failure) => {
  db.collection('notifications/active/list')
    .doc(cellName)
    .onSnapshot(
      doc => {
        success({ id: doc.id, ...doc.data() });
      },
      err => {
        failure(err);
      }
    );
};

export const createNotification = notif => {
  return new Promise((resolve, reject) => {
    db.collection('notifications/list/all')
      .add(notif)
      .then(docRef => {
        resolve({ id: docRef.id, ...notif });
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const activateNotification = async (notif, cellName) => {
  try {

    const inActiveNotifsCollectionRef = db.collection('notifications/list/all');
    const activeNotifDocRef = db.collection('notifications/active/list').doc(cellName);

    inActiveNotifsCollectionRef.doc(notif.id).update({ active: true });

    // Take current notif and add to inactive list
    let oldActiveNotifData = await (await activeNotifDocRef.get()).data();
    if (oldActiveNotifData.set) {
      delete oldActiveNotifData['set'];
      await inActiveNotifsCollectionRef
        .doc(oldActiveNotifData.id)
        .update({ active: false });
    }
    // Update active notif with new data
    await activeNotifDocRef.update({ set: true, ...notif });
    return 'Succefully updated active notification';
  } catch (err) {
    throw err;
  }
};

export const deactivateNotification = async (notif, cellName) => {
  try {
    await db
      .collection('notifications/active/list')
      .doc(cellName)
      .set({ type: '', html: '', set: false });
    await db
      .collection('notifications/list/all')
      .doc(notif.id)
      .update({ active: false });
  } catch (err) {
    throw err;
  }
};

export const deleteNotification = notifId => {
  return new Promise((resolve, reject) => {
    db.collection('notifications/list/all')
      .doc(notifId)
      .delete()
      .then(() => {
        resolve(notifId);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const setClosedReason = (reason: string) => {
  let update;
  const envIsDEV = (
    process.env.REACT_APP_DELIVERY_URL.includes("dev") ||
    process.env.REACT_APP_DELIVERY_URL.includes("uat") ||
    process.env.NODE_ENV === "development"
  )
  if (envIsDEV) {
    update = { eircodeFormDisabledReason_DEV: reason }
  } else {
    update = { eircodeFormDisabledReason: reason }
  }
  return db.collection('notifications')
    .doc('config')
    .update(update)
};

export const getAutoActionsConfig = (cellName: string, day: string, success: (data: any) => void, failure: (error: any) => void) => {
  db.collection('autoActionsConfig')
    .doc(cellName).collection("Days").doc(day).get()
    .then(res => {
      success(res.data())
    })
    .catch(err => {
      failure(err);
    });
};

export const updateAutoActionsConfig = (
  { cellName, day, time, previousTime, actions },
  success: (data: any) => void,
  failure: (error: any) => void
) => {
  db.collection(`autoActionsConfig`)
    .doc(cellName).collection("Days").doc(day).update({
        [previousTime]: fb.firestore.FieldValue.delete()
    })
    .then(() => {
      db.collection(`autoActionsConfig`)
        .doc(cellName)
        .collection("Days")
        .doc(day)
        .update({
          [time]: actions
        })
        .then(res => {
          success(res);
        })
        .catch(err => {
          failure(err);
        });
    })
    .catch(err => {
      failure(err);
    });
};

export const deleteAutoActionsConfig = ({ cellName, day, time }, success: () => void, failure: (error: any) => void) => {
  db.collection(`autoActionsConfig`)
    .doc(cellName)
    .collection("Days")
    .doc(day)
    .update({ [time]: fb.firestore.FieldValue.delete() })
    .then(() => {
      success();
    })
    .catch(err => {
      failure(err);
    });
};


export const getDeliverySlots = (day: string, success: (data: any) => void, failure: () => void) => {
  realtimeDB.ref(`/deliverySlotsDB/${day}`).on(
    'value',
    snapshot => {
      success(snapshot.val());
    },
    () => {
      failure();
    }
  );
};


export const uploadImage = (name: string, file: any) => {
  const storageRef = storage.ref()
  const newImageRef = storageRef.child(name)
  return newImageRef.put(file)
}
